<template>
    <div class="automation-action-settings">
        <div class="field">
            <label>{{ t('automations-form-actions-add_points-points_label') }}</label>
            <input v-if="!using_snippets.points" type="tel" class="form-control" v-model="points" key="points-number" />
            <input v-else type="text" class="form-control" v-model="points" key="points-snippet" :placeholder="t('automations-form-actions-add_points-snippet_placeholder')" />
        </div>
        <div class="field">
            <div class="input-group px-4">
                <div class="d-flex">
                    <input @change="points = using_snippets.points ? '' : 0" v-model="using_snippets.points" id="check-input-points" class="form-check-input" :style="{ 'margin-top': '2.5px' }" type="checkbox" role="switch" />
                    <label class="mb-1" for="check-input-points">{{ t('automations-form-actions-add_points-use_snippets_label') }}</label>
                </div>
            </div>
        </div>
        <div v-if="using_snippets.points">
            <small>
                {{ t('automations-form-actions-add_points-snippets_help') }}
            </small>
            <small>
                <ul>
                    <li class="token" v-for="(token, i) in tokens" :key="i">
                        <span class="copy-token">{{ token }}</span>
                        <a @click="points = token" class="copy-btn"><i class="fa fa-copy"></i></a>
                    </li>
                </ul>
            </small>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        properties: Object,
        conditions: Array,
        actionId: String,
    },
    data: function () {
        return {
            title: this.t("automations-form-actions-add_points-title"),
            description: this.t("automations-form-actions-add_points-description"),
            points: this.properties.points ? this.properties.points : 0,
            using_snippets: {
                points: !!this.properties.using_snippets?.points,
            },
        };
    },
    mounted: function () {
        this.$emit("mounted", this);
    },
    computed: {
        tokens: function () {
            return this.$store.getters["automationForm/tokens"](this.actionId);
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changed: function () {
            this.$emit("propertiesUpdated", {
                points: this.points,
                using_snippets: this.using_snippets,
            });
        },

        isValid: function () {
            if (this.using_snippets.points) {
                return this.tokens.includes(String(this.points).trim());
            }
            return this.points !== "" && !isNaN(this.points);
        },
    },
    watch: {
        properties: function () {
            this.points = this.properties.points;
            this.using_snippets.points = !!this.properties.using_snippets?.points;
        },
        points: function () {
            this.changed();
        },
        using_snippets: {
            handler() {
                this.changed();
            },
            deep: true,
        },
    },
};
</script>
